import React from "react";
import HighlightPopup from "./HighlightPopup";
import {
  AreaHighlight,
  MonitoredHighlightContainer,
  TextHighlight,
  useHighlightContainerContext,
  usePdfHighlighterContext,
} from "react-pdf-highlighter-extended";

const HighlightContainer = ({
  editHighlight,
  onContextMenu,
  editComment,
  deleteComment,
  is_view,
}) => {
  const {
    highlight,
    viewportToScaled,
    screenshot,
    isScrolledTo,
    highlightBindings,
  } = useHighlightContainerContext();

  const { toggleEditInProgress } = usePdfHighlighterContext();

  const isTextHighlight = !Boolean(
    highlight.content && highlight.content.image
  );

  const component = isTextHighlight ? (
    <TextHighlight
      isScrolledTo={isScrolledTo}
      highlight={highlight}
      onContextMenu={(event) =>
        onContextMenu && onContextMenu(event, highlight)
      }
    />
  ) : (
    <AreaHighlight
      isScrolledTo={isScrolledTo}
      highlight={highlight}
      onChange={
        is_view
          ? undefined
          : (boundingRect) => {
              const edit = {
                position: {
                  boundingRect: viewportToScaled(boundingRect),
                  rects: [],
                },
                content: {
                  image: screenshot(boundingRect),
                },
              };

              if (!is_view) {
                editHighlight(highlight.id, edit);
                toggleEditInProgress(false);
              }
            }
      }
      bounds={!is_view ? highlightBindings.textLayer : undefined}
      onContextMenu={
        !is_view
          ? (event) => onContextMenu && onContextMenu(event, highlight)
          : undefined
      }
      onEditStart={!is_view ? () => toggleEditInProgress(true) : undefined}
    />
  );

  const highlightTip = {
    position: highlight.position,
    content: !is_view ? (
      <HighlightPopup
        highlight={highlight}
        editComment={(id) => editComment(id, highlight)}
        deleteComment={(id) => deleteComment(id, highlight)}
      />
    ) : null,
  };

  return (
    <MonitoredHighlightContainer
      key={highlight.id}
      {...(!is_view && { highlightTip })}
    >
      {component}
    </MonitoredHighlightContainer>
  );
};

export default HighlightContainer;
